import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getEventHistoryList = (params) => {
    return axios.get(`${backendHost}/api/admin/cashier/history/list/`, {params});
};

export {
    getEventHistoryList
}